import { TicketsPage } from '@pages/Admin/ErrorTickets/pages/TicketsPage';

export const SupportOtherTickets = () => {
  return <TicketsPage ticketType={2} />;
};
